import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const TodoTables = ({
  toDoRepoData,
  toDoRepoLoading,
  allRepoLoading,
  allRepoData,
  allPrimaryRepoData,
  allPrimaryRepoLoading
}) => {
  const hasEmailReports =
    Array.isArray(toDoRepoData) && toDoRepoData.length > 0;
  const hasAllTodoData =
    allRepoData &&
    typeof allRepoData === "object" &&
    Object.keys(allRepoData).length > 0;
  const hasAllPrimaryTodoData =
    allPrimaryRepoData &&
    typeof allPrimaryRepoData === "object" &&
    Object.keys(allPrimaryRepoData).length > 0;
  return (
    <div className="container-fluid">
      {!allRepoLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div>
              <div className="overflow-auto wb-scrollbar-w-1 mb-3">
                {hasAllTodoData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead>
                      <tr className="text-nowrap">
                        <th>Total Students</th>
                        <th>Primary Email</th>
                        <th>Primary Blank Email</th>
                        <th>Secondary Email</th>
                        <th>Secondary Blank Email</th>
                        <th>Having Both Email</th>
                      </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{allRepoData?.allStudents?.count}</td>
                            <td>{allRepoData?.primaryMails?.count}</td>
                            <td>{allRepoData?.primaryBlankMails?.count}</td>
                            <td>{allRepoData?.altMails?.count}</td>
                            <td>{allRepoData?.altBlankMails?.count}</td>
                            <td>{allRepoData?.bothMails?.count}</td>
                        </tr>
                    </tbody>
                  </table>
                ) : (
                  <p>No data available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3">
          <SkeletonTheme highlightColor="#fff3cd">
            <Skeleton height={70} style={{ marginBottom: "10px" }} />
          </SkeletonTheme>
        </div>
      )}

      {!allPrimaryRepoLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div>
              <div className="overflow-auto wb-scrollbar-w-1 mb-3">
                {hasAllPrimaryTodoData ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead>
                      <tr className="text-nowrap">
                        <th>Total Primary Emails</th>
                        <th>Open Emails</th>
                        <th>Closed Emails</th>
                        <th>In-Process Emails</th>
                        <th>In-Process By Student Emails</th>
                        <th>Re-Open Emails</th>
                        <th>Information Shared Emails</th>
                        <th>Acknowledgement Emails</th>
                      </tr>
                    </thead>
                    <tbody>
                        <tr className="text-center">
                            <td>{allPrimaryRepoData?.totalEmail?.count}</td>
                            <td>{allPrimaryRepoData?.primaryOpenMails?.count}</td>
                            <td>{allPrimaryRepoData?.primaryCloseMails?.count}</td>
                            <td>{allPrimaryRepoData?.primaryInProcessMails?.count}</td>
                            <td>{allPrimaryRepoData?.primaryInProcessStudentMails?.count}</td>
                            <td>{allPrimaryRepoData?.primaryReOpenMails?.count}</td>
                            <td>{allPrimaryRepoData?.primaryInfoSharedMails?.count}</td>
                            <td>{allPrimaryRepoData?.primaryAcknMails?.count}</td>
                        </tr>
                    </tbody>
                  </table>
                ) : (
                  <p>No data available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3">
          <SkeletonTheme highlightColor="#fff3cd">
            <Skeleton height={70} style={{ marginBottom: "10px" }} />
          </SkeletonTheme>
        </div>
      )}

      {!toDoRepoLoading ? (
        <div className="card mb-3">
          <div className="card-body">
            <div className="mb-2">
              <div className="">
                <span className="fs-5 fw-bold text-dark">Email Reports</span>
              </div>
              <div className="py-2 overflow-auto wb-scrollbar-w-1">
                {hasEmailReports ? (
                  <table className="table table-yesgermany table-bordered">
                    <thead className="text-nowrap">
                      <tr>
                        <th>Branch</th>
                        <th>Total Students</th>
                        <th>Total Emails</th>
                        <th>Open Emails</th>
                        <th>Closed Emails</th>
                        <th>In-Process Emails</th>
                        <th>In-Process By Student Emails</th>
                        <th>Re-Open Emails</th>
                        <th>Information Shared Emails</th>
                        <th>Acknowledgement Recieved Emails</th>
                      </tr>
                    </thead>
                    <tbody>
                      {toDoRepoData?.map(({ locname, details }, index) => (
                        <tr key={index} className="text-center">
                          <td className="text-start">{locname}</td>
                          <td className="text-center">
                            {details?.allStudents?.count}
                          </td>
                          <td className="text-center">
                            {details?.primaryTotalMails?.count +
                              details?.altTotalMails?.count}
                          </td>
                          <td className="text-center">
                            {details?.primaryOpenMails?.count +
                              details?.altOpenMails?.count}
                          </td>
                          <td className="text-center">
                            {details?.primaryCloseMails?.count +
                              details?.altCloseMails?.count}
                          </td>
                          <td className="text-center">
                            {details?.primaryInProcessMails?.count +
                              details?.primaryInProcessMails?.count}
                          </td>
                          <td className="text-center">
                            {details?.primaryInProcessStudentMails?.count +
                              details?.altInProcessStudentMails?.count || 0}
                          </td>
                          <td className="text-center">
                            {details?.primaryReOpenMails?.count +
                              details?.altReOpenMails?.count || 0}
                          </td>
                          <td className="text-center">
                            {details?.primaryInfoSharedMails?.count +
                              details?.altInfoSharedMails?.count || 0}
                          </td>
                          <td className="text-center">
                            {details?.primaryAcknMails?.count +
                              details?.altReAcknMails?.count || 0}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No Data to Display</p>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3">
          <SkeletonTheme highlightColor="#fff3cd">
            <Skeleton height={70} style={{ marginBottom: "10px" }} />
          </SkeletonTheme>
        </div>
      )}
    </div>
  );
};

export default TodoTables;
